import { useEffect } from 'react';

import { useSetRecoilState } from 'recoil';

import ProjectPageContainer from 'src/components/ProjectPageContainer';
import { projectStatsParamsState } from 'src/states/stats';
import { Modality } from 'src/types/api/data/image';

import StatsTab from './ManageProject/StatsTab';

interface StatsWrapperProps {
  projectId: string;
  modality: Modality;
}

function StatsWrapper({ projectId, modality }: StatsWrapperProps): JSX.Element {
  const setParams = useSetRecoilState(projectStatsParamsState);

  useEffect(() => {
    setParams({
      projectId,
      modality,
    });
  }, [modality, projectId, setParams]);

  return <StatsTab projectId={projectId} modality={modality} />;
}

export default function ProjectStats(): JSX.Element {
  return (
    <ProjectPageContainer>
      {(projectId, modalityLabel) => (
        <StatsWrapper projectId={projectId} modality={modalityLabel} />
      )}
    </ProjectPageContainer>
  );
}
